import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	position: relative;
	width: 100%;
	height: calc(100% - 60px);
	@media ${Breakpoints.mobileLandscape} {
		height: 100%;
	}
	background-color: var(--white);
	box-shadow: var(--container-box-shadow);
`;

export const MapContainer = styled.div`
	display: flex;
	height: 100%;
	align-items: center;
	padding: 3rem 1rem 1rem 1rem;
	position: relative;
`;

export const BottomContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
`;

export const MapWrapper = styled.div`
	width: 100%;
	height: 100%;
	& > div {
		cursor: default;
	}
`;
export const ListViewButton = styled.div`
	display: none;
	@media ${Breakpoints.mobileLandscape} {
		display: block;
	}
`;
export const ContextMenuButton = css`
	position: absolute;
	top: 0;
	right: 0;
	body[dir='rtl'] & {
		right: unset;
		left: 0;
	}
`;
